import * as Yup from 'yup';
import {ADMIN_PERMISSIONS, GROUND_ADMIN_PERMISSIONS, ROLES} from 'common/constants';

export const subRoleValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Name is required')
    .min(2, 'Name must be at least 2 characters')
    .max(50, 'Name must not exceed 50 characters'),
  description: Yup.string()
    .min(10, 'Description must be at least 10 characters')
    .max(200, 'Description must not exceed 200 characters'),
  role: Yup.string()
    .required('Role is required')
    .oneOf(Object.values(ROLES), 'Invalid role'),
  permissions: Yup.array()
    .min(1, 'At least one permission must be selected')
    .required('Permissions are required'),
});

// Get available permissions based on role type
export const getAvailablePermissions = (roleType) => {
  switch (roleType) {
    case ROLES.ADMIN:
      return Object.values(ADMIN_PERMISSIONS);
    case ROLES.GROUND_ADMIN:
      return Object.values(GROUND_ADMIN_PERMISSIONS);
    default:
      return [];
  }
};

export const getPermissionDisplayName = (permission) => {
  const displayNames = {
    [ADMIN_PERMISSIONS.USERS]: 'Users Management',
    [ADMIN_PERMISSIONS.ROLES]: 'Roles Management',
    [ADMIN_PERMISSIONS.APPROVALS]: 'Approvals',
    [ADMIN_PERMISSIONS.REPORTS]: 'Reports',
    [ADMIN_PERMISSIONS.ANALYTICS]: 'Analytics',
    [ADMIN_PERMISSIONS.WITHDRAWALS]: 'Withdrawal Requests',
    [GROUND_ADMIN_PERMISSIONS.GROUNDS]: 'Grounds Management',
    [GROUND_ADMIN_PERMISSIONS.SLOTS]: 'Fields Management',
    [GROUND_ADMIN_PERMISSIONS.BOOKINGS]: 'Bookings',
    [GROUND_ADMIN_PERMISSIONS.EARNING]: 'Earnings',
    [GROUND_ADMIN_PERMISSIONS.WITHDRAW]: 'Withdrawals',
    [GROUND_ADMIN_PERMISSIONS.NOTIFICATIONS]: 'Notifications',
    [GROUND_ADMIN_PERMISSIONS.OFFLINE_BOOKINGS]: 'Offline Bookings',
    [GROUND_ADMIN_PERMISSIONS.MAINTENANCE]: 'Maintenance',
  };
  return displayNames[permission] || permission;
};